export default {
	publishNamespace: function(prefix, namespace) {
		let publicNamespace = {};
		for (let key in namespace) {
			if (['actions', 'state', 'getters'].indexOf(key) === -1) {
				continue;
			}
			publicNamespace[key] = {};
			for (let idx in namespace[key]) {
				const nameValue = namespace[key][idx];
				publicNamespace[key][nameValue] = prefix + '/' + nameValue;
			}
		}
		return publicNamespace;
	},
	generateNamespace: function(rawNamespace) {
		let namespace = {};
		for (let key in rawNamespace) {
			namespace[key] = {};
			for (let idx in rawNamespace[key]) {
				const nameValue = rawNamespace[key][idx];
				namespace[key][nameValue] = nameValue;
			}
		}
		return namespace;
	},
    compareByLabel: function(userA, userB) {
        var valueA = userA.label.toUpperCase();
        var valueB = userB.label.toUpperCase();
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/store/utils.js